(function () {
  const OVERLAY_ID = 'promo-overlay';
  const STORAGE_KEY = 'promoBannerClosedAt_v1';
  const HIDE_DAYS = 7;
  const SHOW_DELAY_MS = 3000;

  // --- localStorage 安全アクセス ---
  const safeStorage = {
    get() { try { return localStorage.getItem(STORAGE_KEY); } catch(e){ return null; } },
    set(v) { try { localStorage.setItem(STORAGE_KEY, String(v)); } catch(e){} }
  };

  // --- 表示判定 ---
  const shouldShow = () => {
    if (new URLSearchParams(location.search).get('show_promo') === '1') return true;
    const ts = Number(safeStorage.get());
    if (!ts) return true;
    return (Date.now() - ts) > HIDE_DAYS * 24 * 60 * 60 * 1000;
  };

  // --- body直下へ“ポータル”して transform 影響を回避 ---
  const ensurePortalToBody = () => {
    const el = document.getElementById(OVERLAY_ID);
    if (!el) return null;
    if (el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
    return el;
  };

  // --- iOSの可視ビューポート高さにフィット ---
  const fitToVisibleViewport = () => {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    const vh = window.visualViewport
      ? Math.round(window.visualViewport.height)   // “見えている”高さ
      : Math.round(window.innerHeight);

    // bottom/insetに頼らず高さでフルスクリーン化
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.right = '0';
    overlay.style.height = vh + 'px';
    overlay.style.width = '100vw';
    overlay.style.zIndex = overlay.style.zIndex || '99999';
  };

  const bindViewportHandlers = () => {
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', fitToVisibleViewport);
      window.visualViewport.addEventListener('scroll', fitToVisibleViewport);
    }
    window.addEventListener('orientationchange', fitToVisibleViewport);
  };

  // --- 開閉 ---
  const openModal = () => {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    fitToVisibleViewport(); // 開く直前にも再計算
  };

  const closeModal = () => {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    safeStorage.set(Date.now());
  };

  // --- イベントを二重に貼らない ---
  const bindEvents = () => {
    const overlay = document.getElementById(OVERLAY_ID);
    if (!overlay || overlay.dataset.bound === '1') return;

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal(); // バナー外クリックで閉じる
    });

    const closeBtn = overlay.querySelector('.promo-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    overlay.dataset.bound = '1';
  };

  // --- 初期化 ---
  const init = () => {
    const el = ensurePortalToBody();
    if (!el) return;              // HTMLがまだ無ければ何もしない
    bindEvents();
    fitToVisibleViewport();
    bindViewportHandlers();
    if (shouldShow()) setTimeout(openModal, SHOW_DELAY_MS);
  };

  // DOM準備後 + Shopifyセクション再読込対応
  const onReady = () => init();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
  document.addEventListener('shopify:section:load', () => setTimeout(init, 0));
  document.addEventListener('shopify:section:unload', () => {/* noop */});
})();